// extracted by mini-css-extract-plugin
export var container = "_fd-1";
export var editor = "_fd-2";
export var resizable = "_fd-3";
export var wrapper = "_fd-0";